import '.a{display:grid;}.ssr-plugin'
import '.m{gap:1.5rem;}.ssr-plugin'
import { usePopularHousingForms } from './usePopularHousingForms'
import { HousingFormCard } from '@app/components/blocks/card/HousingFormCard'
import defaultHousingFormPicture from '@app/assets/defaultHousingFormPicture.png'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { styled } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'
import { ViewHousingFormModel } from 'functions/app/housing-form/view'

const HousingFormCardItem = ({
  housingForm,
  onClick,
}: {
  housingForm: ViewHousingFormModel & { followerCount: number }
  onClick: () => void
}) => {
  return (
    <HousingFormCard
      image={housingForm.images?.[0]?.src ?? defaultHousingFormPicture}
      title={housingForm.title}
      followers={housingForm.followers ?? []}
      followerCount={housingForm.followerCount}
      onClick={onClick}
    />
  )
}

export const HousingFormPagePopularHousingForms = ({
  excludeIds,
}: {
  excludeIds: (string | number)[]
}) => {
  const [_location, navigate] = useLocation()
  const isMobile = useMediaQuery()
  const { popularHousingForms } = usePopularHousingForms({ excludeIds })

  return (
    <div className="a m"
      style={{
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
      }}
    >
      {popularHousingForms.map((housingForm) => (
        <HousingFormCardItem
          key={housingForm.id}
          housingForm={housingForm}
          onClick={() => navigate(pages.housingForm(housingForm.slug))}
        />
      ))}
    </div>
  )
}
